import { ARCHITECTURE, CORE_PLATFORM, IMAGES } from "../content";
import { Reveal } from "../motion";
import { Section, Wrap, SectionHead } from "./Section";

export default function Architecture() {
  return (
    <Section id="architecture" theme="cream" className="py-16 sm:py-24">
      <Wrap>
        <SectionHead
          eyebrow="Proposed platform architecture"
          title="A broad offer, organised like a garden, not a filing system."
          intro="Four clear branches grow from a dependable core. Visitors find their own route; nobody is forced through the same menu."
        />

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mt-10 sm:mt-12 items-start">
          <Reveal className="lg:col-span-4 lg:sticky lg:top-28">
            <div className="bg-[#26342E] text-[#F6F0E6] rounded-3xl p-8 sm:p-10">
              <div className="rounded-2xl overflow-hidden h-28 mb-7" aria-hidden="true">
                <img src={IMAGES.doorway} alt="" className="w-full h-full object-cover" loading="lazy" />
              </div>
              <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#C29A4A]">The core platform</p>
              <ul className="mt-6 space-y-3">
                {CORE_PLATFORM.map((c) => (
                  <li key={c} className="flex items-center gap-3 text-sm text-[#F6F0E6]/80">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#6F806E]" />
                    {c}
                  </li>
                ))}
              </ul>
              <p className="text-xs leading-relaxed text-[#F6F0E6]/50 mt-8 border-t border-[#F6F0E6]/10 pt-6">
                Managed through a simple content system the team can run without a developer.
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <ol className="space-y-0 border-l border-[#6F806E]/25 pl-8 sm:pl-12">
              {ARCHITECTURE.map((b, i) => (
                <Reveal key={b.branch} delay={i * 0.6}>
                  <li className="relative py-8 first:pt-0 last:pb-0">
                    <span className="absolute -left-8 sm:-left-12 top-8 sm:top-9 w-8 sm:w-12 h-px bg-[#6F806E]/25" aria-hidden="true" />
                    <span className="absolute -left-[37px] sm:-left-[53px] top-[34px] sm:top-[42px] w-2 h-2 rounded-full bg-[#B66E50]" aria-hidden="true" />
                    <h3 className="font-serif text-2xl sm:text-3xl font-light text-[#26342E]">{b.branch}</h3>
                    <div className="flex flex-wrap gap-2 mt-4">
                      {b.items.map((item) => (
                        <span key={item} className="text-xs font-medium text-[#4D5D4C] bg-[#E6E8DE] px-4 py-2 rounded-full">
                          {item}
                        </span>
                      ))}
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </Wrap>
    </Section>
  );
}
